module.exports = __webpack_public_path__ + "static/media/troopr_logo.2ed3a1e6.png";